import React from 'react';
import EmptyState from '@atlaskit/empty-state';
import { useIntl } from 'react-intl-next';
import messages from './messages';
import { PageNotFoundSVG } from '../assets/PageNotFoundSVG';
export var PageNotFoundEmptyState = function PageNotFoundEmptyState() {
  var _useIntl = useIntl(),
    formatMessage = _useIntl.formatMessage;
  return /*#__PURE__*/React.createElement(EmptyState, {
    header: formatMessage(messages.emptyStateHeader),
    description: formatMessage(messages.emptyStateDescription),
    renderImage: function renderImage() {
      return /*#__PURE__*/React.createElement(PageNotFoundSVG, null);
    }
  });
};